import { TOKEN } from '@/constants/token';
import { request } from '@/services/api/requests';
import { ENDPOINTS } from '@/services/endpoints';
import { IAuthProps } from '../model';

export const postAuth = async (data: IAuthProps) => {
  const token = localStorage.getItem(TOKEN);
  return await request.post(ENDPOINTS.AUTH_TOKEN, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSessions = () => {
  return request(ENDPOINTS.AUTH_SESSION).then((res) => res.data);
};
